import {
  ACCESSORIES_FETCHED_SUCCESS,
  ACCESSORIES_FETCHED_FAILURE,
} from '../actions/types';

const initialState = 'NONE';

export default function accessoriesFetchedReducer(
  state = initialState,
  action,
) {
  const { type, payload } = action;
  switch (type) {
    case ACCESSORIES_FETCHED_SUCCESS:
      return payload;
    case ACCESSORIES_FETCHED_FAILURE:
      return 'NONE';

    default:
      return state;
  }
}
